












































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { OrderActions, OrderGetters } from "@/store/modules/order/types";
import CustomersDropdown from "./CustomersDropdown.vue";
import { Order } from "@/models/order/order";
import { DriftReport } from "@/models/quote_draft/quote_draft";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";
import AuthService from "@/services/auth_service";
import { Mobile } from "@/mixins/mobile";
import { EventBus } from "@/event-bus";

@Component({
  components: {
    CustomersDropdown
  },
  directives: {
    "click-outside": {
      bind(el: any, binding: any) {
        el._clickOutside = (e: Event) => {
          if (!el.contains(e.target)) binding.value();
        };
        document.addEventListener("click", el._clickOutside);
      },
      unbind(el: any) {
        document.removeEventListener("click", el._clickOutside);
      }
    }
  } // kept for account dropdown
})
export default class Header extends mixins(Auth, Mobile) {
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetAssignedCustomer))
  customer!: string;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetOrder))
  order!: Order;
  @(namespace(StoreModule.Order).Getter(OrderGetters.GetDriftReport))
  driftReport!: DriftReport | null;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearCustomer))
  clearCustomer!: () => Promise<void>;
  @(namespace(StoreModule.Order).Action(OrderActions.ClearOrder))
  clearOrder!: () => Promise<void>;
  protected menuIsOpen = false;
  protected authService = new AuthService();

  protected showNewQuoteModal = false;
  protected showCustomerDropdown = false;
  protected showAccountDropdown = false;

  /**
   * FUPOF-191: while a loaded quote has unresolved NetSuite line drift the
   * DriftResolver is the only interactive surface — reassigning the customer
   * would reprice lines the user hasn't reconciled yet.
   */
  get hasUnresolvedDrift(): boolean {
    return !!this.driftReport;
  }

  /** The cart already renders the DriftResolver itself — the banner is only
   * needed to explain the lock on every other route. */
  get showDriftBanner(): boolean {
    return this.hasUnresolvedDrift && this.$route.name !== "Cart";
  }

  get customerLockReason(): string {
    return this.hasUnresolvedDrift
      ? "This quote was changed in NetSuite. Review the changes in your cart before changing the customer."
      : "";
  }

  protected toggleCustomerDropdown(): void {
    if (this.hasUnresolvedDrift) return;
    this.showCustomerDropdown = !this.showCustomerDropdown;
  }

  protected closeCustomerDropdown(): void {
    this.showCustomerDropdown = false;
  }

  protected toggleAccountDropdown(): void {
    this.showAccountDropdown = !this.showAccountDropdown;
  }

  protected closeAccountDropdown(): void {
    this.showAccountDropdown = false;
  }

  protected toggleSidebar(): void {
    this.menuIsOpen = !this.menuIsOpen;
    EventBus.$emit("toggleSidebar");
  }

  mounted() {
    EventBus.$on("sidebarClosed", () => {
      this.menuIsOpen = false;
    });
    EventBus.$on("openCustomerModal", () => {
      if (this.hasUnresolvedDrift) return;
      this.showCustomerDropdown = true;
    });
  }

  beforeDestroy() {
    EventBus.$off("sidebarClosed");
    EventBus.$off("openCustomerModal");
  }

  get isReviewPage(): boolean {
    return this.$route.name === "OrderReview";
  }

  get totalQty(): number {
    let qty = 0;
    if (this.order.items && this.order.items.length) {
      for (const item of this.order.items) {
        qty = qty + item.qty;
      }
    }
    return qty;
  }

  /**
   * FUPOF-191 (FT-1): a user-initiated logout that happens mid-draft-edit
   * clears the draft-edit state and the cart — the draft is already safe in
   * PSQL, and leaving `draft_id` behind would let the next session reopen a
   * quote it may not own. A plain (non-draft) cart is deliberately preserved
   * in localStorage so the same user can pick it back up on next login;
   * BIGGER-TWEAKS #2's user-change guard wipes it if someone else logs in.
   *
   * Forced logouts (401 → AuthError.logout()) intentionally do *not* run this
   * — a session timeout should not destroy work the user didn't choose to end.
   */
  public async logout(): Promise<void> {
    try {
      if (this.order.draft_id) {
        await this.clearOrder();
      }
      this.setLoggedIn(false);
      this.setUserRole(null);
      this.setAuthToken(null);
      this.setImpersonation(null);
      await this.authService.logout();
      const callback = `${process.env.VUE_APP_URL}/auth/callback`;
      const loginUrl = `${process.env.VUE_APP_API_LARAVEL_URL}/auth/login?redirect=${encodeURIComponent(callback)}&app=${process.env.VUE_APP_SSO_APP_SLUG}`;
      window.location.replace(
        `${process.env.VUE_APP_API_LARAVEL_URL}/auth/logout?redirect=${encodeURIComponent(loginUrl)}`
      );
    } catch (err) {
      // On error, still redirect to login
      window.location.replace("/login");
    }
  }
}
